import { useState } from "react";
import { AlertTriangle } from "lucide-react";

import { ChildMessagesStore } from "@/components/Playground/Messages/PlaceholderContainer/stores/child-messages-store";
import { cn } from "@/lib/utils";

export const ContainerLevelError = ({ childStore }: { childStore: ChildMessagesStore }) => {
  const [isTruncated, setIsTruncated] = useState<boolean>(true);

  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-t-lg border-b text-sm ",
        "px-3 py-2",
        "border-red-200 bg-red-50 text-red-700",
        "cursor-pointer",
      )}
      onClick={() => setIsTruncated(!isTruncated)}
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <span className={cn(isTruncated && "truncate")}>
        JSON parse error: {childStore.parseError}
      </span>
    </div>
  );
};
